import * as React from "react";
import { useTheme } from '@material-ui/core/styles';
import { defaultInputProps, useRootStyles } from "./globalprops"
import { InputAdornment, TextField } from "@material-ui/core";
import { Loading } from "./Loading";
import { ICommonInputsControlsWithLabel } from "./ICommonInputsControls";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    rows?: number;
    maxRows?: number;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControlsWithLabel<string>;
export const TextBoxMultiLine = (props: AllProps) => {
    const classes = useRootStyles(useTheme());
    const { t: tCommon } = useTranslation('common');

    const calculateError = (newValue: string | null): [boolean, string] => {
        if (props.required && (!newValue || newValue.trim() === "")) {
            return[true, tCommon('xIsRequired', {x: props.label})];
        }    
        return props.onValidate ? props.onValidate(newValue) : [false, ""];
    }

    const [value, setValue] = React.useState(props.value || null);
    const [error, setError] = React.useState<[boolean, string]>(props.error || [false, ""]);
    const hasPrevalidated = React.useRef(false);

    const doChange = (newValue: string | null) => {
        setValue(newValue);
        const myError: [boolean, string] = calculateError(newValue);
        setError(myError);
        props.onChange && props.onChange(newValue || "", !myError[0]);
    }

    React.useEffect(() => {
        if (props.prevalidate && !hasPrevalidated.current) {
            hasPrevalidated.current = true;
            const myError: [boolean, string] = calculateError(value);
            setError(myError);
            // Only call onChange for the initial prevalidation if we have a meaningful value
            if (props.onChange && (value !== null && value !== "")) {
                props.onChange(value || "", !myError[0]);
            }
        }
    }, [props.prevalidate]);

    React.useEffect(() => {
        setValue(props.value || null);
        setError(props.error || [false, ""]);
    }, [props.value, props.error]);

    return (props.loading ? <Loading label={props.label} /> : <TextField
            {...defaultInputProps}
            className={classes.root}
            label={props.label}
            placeholder={props.placeholder}
            disabled={props.disabled || props.loading}
            value={value || ""}
            multiline={true}
            minRows={props.rows || 3}
            maxRows={props.maxRows || props.rows || 6}
            onChange={(e) => {
                const v = e.target.value === "" ? null : e.target.value;
                doChange(v);
            }}
            error = {error[0]}
            helperText = { error[0] ? error[1] : undefined }
            InputProps={{
                startAdornment : props.icon && <InputAdornment position="start">{props.icon}</InputAdornment>
            }}
            required={props.required}
        />)
}
